export const INSERT_NOC_TYPE_MUTATION = `
  mutation InsertNocType($input: NocTypeInsertInput!) {
    insertNocType(input: $input) {
      itemId
      totalImpactedData
      acknowledged
    }
  }
`;

export const UPDATE_NOC_TYPE_MUTATION = `
  mutation UpdateNocType($filter: String!, $input: NocTypeUpdateInput!) {
    updateNocType(filter: $filter, input: $input) {
      itemId
      totalImpactedData
      acknowledged
    }
  }
`;

export const DELETE_NOC_TYPE_MUTATION = `
  mutation DeleteNocType($filter: String!, $input: NocTypeDeleteInput!) {
    deleteNocType(filter: $filter, input: $input) {
      acknowledged
      totalImpactedData
    }
  }
`;
